import type React from 'react'

import { CoreRemixIconNameMap, isCoreIconName } from './remix/core.ts'
import {
  RemixFillIconComponents,
  RemixLineIconComponents,
  remixIconNameToKey,
} from './remix/types.ts'
import { svgIconMap } from './svg/types/maps.ts'
import { isSvgIconName } from './svg/types/names.ts'
import type { IconProps } from './types/props.ts'

export const IconComponentFactory = ({
  name,
  fill,
  size,
  color,
  strokeWidth,
}: IconProps): React.ComponentType<React.SVGProps<SVGSVGElement>> => {
  if (isCoreIconName(name)) {
    return fill === 'solid'
      ? RemixFillIconComponents[
          remixIconNameToKey(CoreRemixIconNameMap[name], 'solid')
        ]
      : RemixLineIconComponents[
          remixIconNameToKey(CoreRemixIconNameMap[name], 'outline')
        ]
  }

  if (isSvgIconName(name)) {
    const IconComponent = svgIconMap[name]
    return (props) => (
      <IconComponent {...{ ...props, size, fill, name, color, strokeWidth }} />
    )
  }

  return () => null
}
